-<template>
  <section 
    id="as-section-listings"
    class="as-section as-section--has-padding as-section--listings"
    :class="mapView == 1 ? 'as-section--listings--map-shown' : ''" 
    data-section="listings">
    
    <div class="container">

      <div class="as-section__intro">
        <h2 class="as-section__title">
          Listings <template v-if="listingsType && listingsType == 'for-sale'">for Sale</template><template v-else>for Rent</template>
        </h2>
        <template v-if="locationText">
          <h3 class="as-section__sub-title">
            <i class="fal fa-map-marker-alt mr-1 text-success"></i>{{locationText}}
          </h3>
        </template>
        <a href="#" @click.prevent="$emit('toggle-map')" class="btn btn--cta btn--cta--primary btn--cta--pill btn--cta--primary text-nowrap" :class="{}">
          <template v-if="mapView == -1">
            <i class="fal fa-map-marker-alt"></i>
            <span class="the-text">View Map</span>
          </template>
          <template v-else>
            <i class="fal fa-times"></i>
            <span class="the-text">Close Map</span>
          </template>
        </a>
      </div>

      <div class="as-listing-controls">

        <fieldset class="radio-btns">
          <legend class="label-text sr-only">Which type of listings would you like to view?</legend>
          <div class="radio-btns-track">
            <label for="listings-view-agent" class="radio-btn">
              <input 
                id="listings-view-agent" 
                type="radio" 
                v-model="view" 
                value="agent" 
                class="radio-btn__input">
              <div class="radio-btn__indicator">My Listings</div>
            </label>
            <label for="listings-view-all" class="radio-btn">
              <input 
                id="listings-view-all" 
                type="radio" 
                v-model="view" 
                value="all" 
                class="radio-btn__input">
              <template v-if="listingsType == 'for-rent'">
                <div class="radio-btn__indicator">All Office Listings</div>
              </template>
              <template v-else-if="listingsType == 'for-sale'">
                <div class="radio-btn__indicator">All Listings</div>
              </template>
            </label>
          </div>
        </fieldset>

        <div class="as-listing-controls__filter-bar">
          <rw-autocomplete 
              :hide-label="true" 
              :location-text="searchParams.location_txt"
              label-text="Search location"
              @selection="onLocationSearchSelect">
          </rw-autocomplete>

          <label for="as-listing-filters-listing-type-input" class="rwfc rwfc--select as-listing-controls__search-type-input-wrapper mr-md-1">
              <span class="sr-only">Search Type</span>
              <div class="rwfc__dropdown-triangle-layer">
                <select 
                    id="as-listing-filters-listing-type-input"
                    class="rwfc__input"
                    @change="$emit('listings-type-change', $event.target.value)">
                    <option value="for-sale" :selected="listingsType == 'for-sale'">For Sale</option>
                    <option value="for-rent" :selected="listingsType == 'for-rent'">For Rent</option>
                </select>
              </div>
          </label>

          <div class="rw-building-types-multiple as-listing-controls__building-type-input-wrapper mr-md-1">
            <select2-multiple
              :input-name="'building_types'"
              :input-id="'rwrw-building-types'"
              :label-text="'Building Types'"
              :place-holder-text="'All Property Types'"
              v-model="computedBuildingTypes"
              :options="select2BuildingTypes"
            >
              <template slot="options" slot-scope="{ options }">
                <option
                  v-for="option in options"
                  :key="option.id"
                  :value="option.id"
                  :selected="searchParams.building_types.includes(option.text)"
                >
                  {{ option.text }}
                </option>
              </template>
            </select2-multiple>
          </div>


          <filter-dropdown
              :dropdown-id="'as-listing-filters-asking-price-filter-dropdown'"
              :field-label="priceFieldLabel || 'Price'"
              :is-active="priceFieldLabel !== false"
              :extra-classes="'d-md-flex mr-md-1'"
          >
              <min-max-controls
                  :min-symbol-before="'$'"
                  :max-symbol-before="'$'"
                  :min-el-id="'as-listing-filters-min-asking-price'"
                  :max-el-id="'as-listing-filters-max-asking-price'"
                  :min-val="searchParams[`min_asking_price`]"
                  :max-val="searchParams[`max_asking_price`]"
                  :min-wrapper-class="formValidation[`min_asking_price`].$error ? 'rwfc--error' : ''"
                  :max-wrapper-class="formValidation[`max_asking_price`].$error ? 'rwfc--error' : ''"
                  :min-label="'Minimum Price'"
                  :max-label="'Maximum Price'"
                  @min-value-changed="onFilterChange({min_asking_price: $event})"
                  @max-value-changed="onFilterChange({max_asking_price: $event})">
              </min-max-controls>
          </filter-dropdown>


          <filter-dropdown
              :dropdown-id="'as-listing-filters-beds-filter-dropdown'"
              :field-label="bedsLabel || 'Beds'"
              :is-active="bedsLabel !== false"
              :extra-classes="'d-md-flex mr-md-1'"
          >
              <min-max-controls
                  :min-el-id="'as-listing-filters-min-beds'"
                  :max-el-id="'as-listing-filters-max-beds'"
                  :min-val="searchParams[`min_beds`]"
                  :max-val="searchParams[`max_beds`]"
                  :min-label="'Minimum Beds'"
                  :max-label="'Maximum Beds'"
                  @min-value-changed="onFilterChange({min_beds: $event})"
                  @max-value-changed="onFilterChange({max_beds: $event})">
              </min-max-controls>
          </filter-dropdown>

          <template v-if="listingsType == 'for-sale'">
            <filter-dropdown
                :dropdown-id="'as-listing-filters-gross-yield-filter-dropdown'"
                :field-label="grossYieldLabel || 'Gross Yield'"
                :is-active="grossYieldLabel !== false"
                :extra-classes="'d-md-flex'">
                <min-max-controls
                    :min-symbol-after="'%'"
                    :max-symbol-after="'%'"
                    :min-el-id="'as-listing-filters-min_gross_yield'"
                    :max-el-id="'as-listing-filters-max_gross_yield'"
                    :min-val="searchParams[`min_gross_yield`]"
                    :max-val="searchParams[`max_gross_yield`]"
                    :min-label="'Minimum Gross Yield'"
                    :max-label="'Maximum Gross Yield'"
                    @min-value-changed="onFilterChange({min_gross_yield: parseFloat($event)})"
                    @max-value-changed="onFilterChange({max_gross_yield: parseFloat($event)})">
                </min-max-controls>
            </filter-dropdown>
          </template>

        </div>

      </div>


      <div class="as-listing-results__wrapper">

        <div class="as-listing-results__loading-layer" :class="loading ? 'as-listing-results__loading-layer--shown' : ''">
          <i class="rw-loading-spinner"></i>
        </div>

        <p 
          class="rwps__results-heading rwps__results-heading--in mb-2">
            <strong>
              <template v-if="hasListings">
                Showing
                <template v-if="totalCnt == 1"> 1 Result</template>
                <template v-else>
                  Results {{ startingIndex }} - {{ endingIndex }} of {{ totalCnt | numberWithCommas }} 
                </template>
              </template>
              <template v-else-if="mapView == 1">
                No results found. 
              </template> 
            </strong>
            <template v-if="!listings.length && mapView == 1">Adjust the filters or drag, pinch, or zoom to move around the map and find new results</template>
        </p>

        <div class="rwps__map" :class="mapView == 1 ? 'rwps__map--shown' : ''">


          <property-search-map 
              v-if="Math.abs(mapConfig.center.lat)"
              :markers="listings"
              :map-config="mapConfig"
              :info-window-position="infoWindowPosition"
              :highlighted-property="highlightedProperty"
              :search-type="searchParams.listingsType"
              @map-idle="onMapIdle"
              @center-change="onCenterChange"
              @bounds-change="onBoundsChange"
              @drag-start="onDragStart"
              @drag-end="onDragEnd"
              @marker-mouse-over="onHighlightProperty($event)"
              @marker-mouse-out="onClearHighlightedProperty($event.id)"
              @marker-click="onMarkerClick"
              @marker-touchend="onMarkerTouchend($event)"
          ></property-search-map>


        </div>


        <template v-if="initialized && !loading && !hasListings">
          <div class="as-section__empty-state">
            <div class="as-section__empty-state__icon">
              <i class="fad fa-search"></i>
            </div>
            <h3 class="as-section__empty-state__heading"><strong>Oops!</strong> Looks like your search returned no results.</h3>
            <template v-if="searchParams.listingsView == 'agent'">
              <p class="as-section__empty-state__sub-heading">
                You are currently viewing listings assigned to {{agent.first_name}} {{agent.last_name}}.<br/>
                Would you like to view inventory for all of {{locationText}}?
              </p>
              <div class="text-center">
                <a 
                  href="#" 
                  @click.prevent="$emit('listings-view-change', 'all')"
                  :title="`View Listings for all of ${locationText}`" 
                  class="btn btn--cta btn--cta--primary btn--cta--pill my-2">
                    <span class="the-text">View {{locationText}} Listings</span>
                </a>
              </div>
            </template>
            <template v-else>
              <p class="as-section__empty-state__sub-heading">
                Please use the filters above to search a new location or adjust your search criteria
              </p>
            </template>
          </div>
        </template>


        <template v-if="mapView == -1">

          <div class="property-photo-cards-wrapper">
            <div class="container px-0" v-if="hasListings">
                <property-photo-card 
                    v-for="listing in listingGroups[0]" 
                    :key="listing.id"
                    :id="'property-card-' + listing.id"
                    :property="listing"
                    :search-type="listingsType"
                >
                </property-photo-card>
            </div>
            <div class="container px-0" v-else-if="loading && !hasListings">
                <div class="property-photo-card property-photo-card--loader" v-for="(property, key) in 6" :key="key">
                    <div class="property-photo-card__thumb-wrapper">
                        <div class="property-photo-card__background"></div>
                    </div>
                    <div class="property-photo-card__footer d-flex justify-content-between align-items-center">
                        <i class="fas fa-spin fa-spinner"></i>
                        <span>---</span>
                    </div>
                </div>
            </div>
        </div>

        <template v-if="hasListings && agent.agent_page.quote">
          <blockquote class="as-listing-quote">
            <span class="agent-website__avatar">
              <img
                class="agent-website__avatar-img"
                v-if="agent && agent.avatar"
                :src="storageDir + `/avatars/${agent.avatar}`"
                :alt="`User avatar for ${agent.first_name} ${agent.last_name}`"
              />
              <img
                v-else
                :src="storageDir + '/avatars/default.jpg'"
                class="agent-website__avatar-img"
                alt="Default user avatar"
              />
            </span>
            <div class="as-listing-quote__body">
              <p>“{{agent.agent_page.quote}}” - {{agent.first_name}} {{agent.last_name}}</p>
            </div>
          </blockquote>
        </template>

        <template v-if="listingGroups[1] && listingGroups[1].length > 0">

          <div class="property-photo-cards-wrapper">
              <div class="container px-0" v-if="hasListings">
                  <property-photo-card 
                      v-for="listing in listingGroups[1]" 
                      :key="listing.id"
                      :id="'property-card-' + listing.id"
                      :property="listing"
                      :search-type="listingsType"
                  >
                  </property-photo-card>
              </div>
              <div class="container px-0" v-else-if="loading && !hasListings">
                  <div class="property-photo-card property-photo-card--loader" v-for="(property, key) in 6" :key="key">
                      <div class="property-photo-card__thumb-wrapper">
                          <div class="property-photo-card__background"></div>
                      </div>
                      <div class="property-photo-card__footer d-flex justify-content-between align-items-center">
                          <i class="fas fa-spin fa-spinner"></i>
                          <span>---</span>
                      </div>
                  </div>
              </div>
          </div>

        </template>
          
        </template>

      </div>



      <!-- Used for disclaimer section -->
      <slot></slot>

      
    </div><!-- end .container -->

  </section>
</template>

<script>
import { mapMutations, mapGetters, mapActions, mapState } from 'vuex';
import fieldTypes from '@assets/data/property-search-field-types';
import { convertToThousandsLabel, convertField } from '@vue/store/helpers';
import PropertySearchFiltersMixin from '@vue/mixins/property-search-filters-mixin';
import WaypointMixin from '@vue/mixins/waypoint-mixin';
import buildingTypes from '@assets/data/building-types';

import PropertySearchMap from '@vue/components/rwps/PropertySearchMap.vue';
import PropertyPhotoCard from '@vue/components/properties/PropertyPhotoCard.vue';
import RwAutocomplete from '@vue/components/inputs/RwAutocomplete.vue';
import FilterDropdown from '@vue/components/util/FilterDropdown.vue';
import MinMaxControls from '@vue/components/inputs/MinMaxControls.vue';
import Select2Multiple from "@vue/components/select2/Select2Multiple.vue";

export default {
  mixins: [
    PropertySearchFiltersMixin,
    WaypointMixin
  ],
  components: {
    Select2Multiple,
    PropertyPhotoCard,
    RwAutocomplete,
    FilterDropdown,
    MinMaxControls,
    PropertySearchMap
  },
  
  props: {
    initialized: {
      type: Boolean,
      required: true
    },
    searchParams: {
      type: Object,
      required: true
    },
    agent: {
      type: Object,
      required: true
    },
    listingsType: {
      type: String
    },
    listingsView: {
      type: String
    },
    storageDir: {
      type: String
    },
    formValidation: {
      type: Object,
      required: true
    },
    // mlsName: {
    //   type: String
    // },
    locationText: {
      type: String
    },
    listings: {
      type: Array,
      default: () => {
        return [];
      }
    },
    markers: [],
    mapConfig: {},
    highlightedProperty: {},
    infoWindowPosition: {},
    loading: {
      type: Boolean
    },
    mapView: {
      type: Number
    },
    startingIndex: {
      type: Number
    },
    endingIndex: {
      type: Number
    },
    totalCnt: {
      type: Number
    }
  },
  mounted() {
  
  },
  data(){
    return {
      buildingTypes
    }
  },
  computed: {
   
    type: {
      get(){
        return this.searchParams.listingsType;
      },
      set(searchType){
        this.$emit('listings-type-change', searchType);
      }
    },
    view: {
      get(){
        return this.searchParams.listingsView;
      },
      set(searchView){
        this.$emit('listings-view-change', searchView);
      }
    },
    hasListings(){
      return this.listings && this.listings.length > 0;
    },

    priceFieldLabel(){
        let minFilter = false;
        let maxFilter = false;
        minFilter = this.searchParams.min_asking_price;
        maxFilter = this.searchParams.max_asking_price;

        if(minFilter && maxFilter){
            return convertToThousandsLabel(minFilter, this.listingsType) + ' - ' + convertToThousandsLabel(maxFilter, this.listingsType);
        } else if(minFilter){
            return '> ' + convertToThousandsLabel(minFilter, this.listingsType);
        } else if(maxFilter){
            return '< ' + convertToThousandsLabel(maxFilter, this.listingsType);
        }
        return false;
    },

    bedsLabel(){
        let minFilter = false;
        let maxFilter = false;
        minFilter = this.searchParams.min_beds
        maxFilter = this.searchParams.max_beds

        if(minFilter && maxFilter){
            return minFilter + ' - ' + maxFilter + ' beds';
        } else if(minFilter){
            return '> ' + minFilter + ' beds';
        } else if(maxFilter){
            return '< ' + maxFilter + ' beds';
        }
        return false;
    },

    grossYieldLabel(){
        let minFilter = false;
        let maxFilter = false;
        minFilter = this.searchParams.min_gross_yield;
        maxFilter = this.searchParams.max_gross_yield;

        if(minFilter && maxFilter){
            return minFilter + '% - ' + maxFilter + '% GY';
        } else if(minFilter){
            return '> ' + minFilter + '% GY';
        } else if(maxFilter){
            return '< ' + maxFilter + '% GY';
        }
        return false;
    },

    listingGroups(){
      let firstGroupLength = 6;
      /**
       * On tablets, need to avoid breaking the groups 
       */
      if(window.outerWidth >= 768 && window.outerWidth < 992){
        firstGroupLength = 4;
       } else if(this.listings.length > 2 && this.listings.length < 6) {
        firstGroupLength = Math.ceil(this.listings.length / 2);
      }
      
      let firstGroup = this.listings.length > firstGroupLength ? this.listings.filter((item, index) => index < firstGroupLength) : this.listings;
      let secondGroup = this.listings.length > firstGroupLength ? this.listings.filter((item, index) => index >= firstGroupLength) : [];

      return [
        firstGroup,
        secondGroup
      ]
    },

    buildingTypeDropdownOptions(){
      if(this.listingsType == 'for-sale'){
        return this.buildingTypes.mls;
      } else {
        return this.buildingTypes.internal;
      }
    },

    computedBuildingTypes: {
      get() {
        return this.searchParams.building_types;
      },
      set(value) {
        this.emitFilterChange({ building_types: value });
      },
    },

    select2BuildingTypes(){
      let typesToUse = {};
      let types = [];
      if(this.listingsType == 'for-sale'){
        typesToUse = {...this.buildingTypes.mls};
      } else {
        typesToUse = {...this.buildingTypes.internal};
      }
      console.log(typesToUse);
      for(let key in typesToUse){
        types.push({
          id: key,
          text: typesToUse[key]
        })
      }
      return types;
    },
    
  },
  methods: {

    onLocationSearchSelect(params){
      this.$emit('location-search-select', params);
    },

    onFilterChange(params){
      let obj = {};
      let fieldName = Object.keys(params)[0];
      let value = Object.values(params)[0];
      let readingIn = false;
      obj[fieldName] = convertField(fieldTypes, fieldName, value, readingIn);
      console.log({fieldTypes, fieldName, value});
      console.log(obj);
      this.$emit('filter-change', obj);
    },

    onMapIdle(params){
      this.$emit('map-idle', params);
    },

    onCenterChange(params){ this.$emit('center-change', params); },
    onHighlightProperty(params){ this.$emit('highlight-property', params); },
    onBoundsChange(params){ this.$emit('bounds-change', params); },
    onDragStart(params){ this.$emit('drag-start', params); },
    onDragEnd(params){ this.$emit('drag-end', params); },
    onMarkerMouseOver(params){ this.$emit('marker-mouse-over', params); },
    onClearHighlightedProperty(params){ this.$emit('clear-highlighted-property', params); },
    onMarkerClick(params){ this.$emit('marker-click', params); },
    onMarkerTouchend(params){ this.$emit('marker-touchend', params); },
    
  },
  watch: {
    listings(){
      try {
        // this.$removeObserver(this.$el, this.onWaypointEnter, this.intersectionOptions);
      } catch(e){
        console.warn(e);
      }
      this.$addObserver(this.$el, this.onWaypointEnter, this.intersectionOptions);
    }
  }
}
</script>